import React from "react";
import ColorModeProvider from "./components/BaseColorModeProvider";
import { jsx as _jsx } from "react/jsx-runtime";
export function LightModeProvider(_ref) {
  var children = _ref.children;
  return /*#__PURE__*/_jsx(ColorModeProvider, {
    mode: "light",
    children: children
  });
}
export function DarkModeProvider(_ref2) {
  var children = _ref2.children;
  return /*#__PURE__*/_jsx(ColorModeProvider, {
    mode: "dark",
    children: children
  });
}